import { Component, OnInit, Input } from '@angular/core';
import { EmployeeService } from '../../../../employee.service';
import { NewEmployeeComponent } from '../../../../new-employee/new-employee.component';
import { SasisopaService } from '../../../../services/sasisopa.service';
import { NbDialogRef, NbDialogService } from '@nebular/theme';
import Swal, { SweetAlertIcon } from 'sweetalert2';
import * as moment from 'moment';

@Component({
  selector: 'ngx-training-evaluation',
  templateUrl: './training-evaluation.component.html',
  styleUrls: ['./training-evaluation.component.scss']
})
export class TrainingEvaluationComponent implements OnInit {
  @Input() stationId: string;
  @Input() action: string;
  @Input() infoEdit: any;
  loading = false;
  employees = [];
  courses = [];
  questions: any = [
    {
      question: ''
    }
  ];
  questionsTrueFalse: any = [
    {
      question: ''
    }
  ];
  questionsMultiple: any = [
    {
      question: ''
    }
  ];
  data: any = {
    mode: {
      internal: false,
      external: false,
    }
  };
  today = new Date();
  year = moment(this.today).format('YYYY')

  constructor(
    private employeeService: EmployeeService,
    private dialogService: NbDialogService,
    private sasisopaService: SasisopaService,
    protected ref: NbDialogRef<TrainingEvaluationComponent>,
  ) { }

  async ngOnInit() {
    this.loading = true
    if (this.action === 'edit') {
      this.stationId = this.infoEdit.station_id
    }
    await this.getEmployees()
    await this.getTrainings()
    this.loading = false
  }

  async getEmployees() {
    const [err, result] = await this.employeeService.getEmployees(this.stationId);
    if (err) return this.alert('Oops, intenta más tarde [Error. Lista empleados]', 'error');
    this.employees = result.data;
  }

  async getTrainings() {
    const [err, result] = await this.sasisopaService.getTrainingLists(this.stationId, this.year);
    if (err) return this.alert('Oops, intenta más tarde [Error. Lista empleados]', 'error');
    console.log();
    this.courses = result;
  }

  alert(title: string = 'asdasd', type: SweetAlertIcon = 'success', text: string = '') {
    return Swal.fire({
      icon: type,
      title: title,
      text: text,
    });
  }

  openNewEmployee() {
    this.dialogService.open(NewEmployeeComponent, {
      hasScroll: true,
      context: {
        stationId: this.stationId,
      },
    }).onClose.subscribe(employeeStored => employeeStored ? this.getEmployees() : null);
  }

  addQuestion() {
    this.questions.push({
      question: ''
    })
  }

  addQuestionTrueFalse() {
    this.questionsTrueFalse.push({
      question: ''
    })
  }

  addQuestionMultiple() {
    this.questionsMultiple.push({
      question: ''
    })
  }

  getTrainingMode($event: any) {
    console.log($event);
    this.data.mode.internal = $event.mode.internal
    this.data.mode.external = $event.mode.external
  }

}
